import React, { useMemo } from "react";
import { VisuallyHiddenElement } from "shared/styles/constants";
import { ITheme } from "shared/types";

import { StyledButton, StyledButtonProps } from "./styles";
import { CSSProperties } from "styled-components";

export interface ButtonProps extends StyledButtonProps {
  id?: string;
  "data-testid"?: string;
  disabled?: boolean;
  type?: "submit" | "button";
  className?: string;
  value?: string;
  "aria-label"?: string;
  onClick?: () => void;
  style?: CSSProperties;
}

export const Button: React.FC<ButtonProps> = ({
  theme = ITheme.primary,
  size = "m",
  type = "button",
  onClick,
  children,
  fakeHidden,
  disabled,
  style,
  ...rest
}) => {
  const content = useMemo(
    () => (
      <StyledButton
        size={size}
        theme={theme}
        type={type}
        onClick={onClick}
        fakeHidden={fakeHidden}
        tabIndex={fakeHidden ? -1 : 0}
        disabled={disabled}
        {...rest}
        style={style}
      >
        {children}
      </StyledButton>
    ),
    [children, fakeHidden, onClick, disabled, rest, size, theme, type, style]
  );

  if (fakeHidden) return <VisuallyHiddenElement>{content}</VisuallyHiddenElement>;

  return content;
};
